import React, { Suspense, useState } from 'react';
import { EditorRulesPage } from './inputBlockRules';
import { LinearProgress, Stack } from '@mui/material';
import { Rules } from './rules';

export interface CreatingNewRuleProps {
  isCreatingNewRule: boolean;
  setIsCreatingNewRule: React.Dispatch<React.SetStateAction<boolean>>;
  showAllRules: boolean;
  setShowAllRules: React.Dispatch<React.SetStateAction<boolean>>;
  hasUnsavedChanges: boolean;
  setHasUnsavedChanges: React.Dispatch<React.SetStateAction<boolean>>;
}
const RulesPage = () => {
  const [showAllRules, setShowAllRules] = useState<boolean>(false);
  const [isCreatingNewRule, setIsCreatingNewRule] = useState<boolean>(false);
  const [hasUnsavedChanges, setHasUnsavedChanges] = useState<boolean>(false);

  return (
    <Stack direction={'row'} spacing={0}>
      <Suspense fallback={<LinearProgress />}>
        <Rules
          isCreatingNewRule={isCreatingNewRule}
          setIsCreatingNewRule={setIsCreatingNewRule}
          showAllRules={showAllRules}
          setShowAllRules={setShowAllRules}
          hasUnsavedChanges={hasUnsavedChanges}
          setHasUnsavedChanges={setHasUnsavedChanges}
        />
      </Suspense>
      <EditorRulesPage
        isCreatingNewRule={isCreatingNewRule}
        setIsCreatingNewRule={setIsCreatingNewRule}
        showAllRules={showAllRules}
        setShowAllRules={setShowAllRules}
        hasUnsavedChanges={hasUnsavedChanges}
        setHasUnsavedChanges={setHasUnsavedChanges}
      />
    </Stack>
  );
};

export default RulesPage;
